var map = {
	"./components/classrooms/ClassroomDetailsIndex.vue": 2117,
	"./components/classrooms/ClassroomFormDialog.vue": 22166,
	"./components/classrooms/ClassroomIndex.vue": 4636,
	"./components/classrooms/SchoolImportDialog.vue": 13083,
	"./components/classrooms/TeachingMaterialsIndex.vue": 69836,
	"./components/dashboard/Dashboard.vue": 68761,
	"./components/dashboard/widgets/ActiveUsersWidget.vue": 24099,
	"./components/dashboard/widgets/MinutesPlayedWidget.vue": 49157,
	"./components/dashboard/widgets/NewUsersWidget.vue": 15109,
	"./components/dashboard/widgets/PlanetsFinishedWidget.vue": 31474,
	"./components/dashboard/widgets/TotalSchoolsWidget.vue": 40400,
	"./components/emails/EmailFormDialog.vue": 82415,
	"./components/emails/EmailImportDialog.vue": 62050,
	"./components/emails/EmailIndex.vue": 22197,
	"./components/faqs/FaqsActions.vue": 34650,
	"./components/faqs/FaqsIndex.vue": 28688,
	"./components/game/GameCertificate.vue": 36160,
	"./components/game/GameCockpit.vue": 96850,
	"./components/game/GameLogin.vue": 89388,
	"./components/game/GameOnboarding.vue": 34553,
	"./components/game/GameRouteList.vue": 75587,
	"./components/game/GameShop.vue": 3186,
	"./components/game/SurveyDialog.vue": 25598,
	"./components/game/achievements/GameAchievements.vue": 74599,
	"./components/game/achievements/GameAchievementsTabBadges.vue": 40805,
	"./components/game/achievements/GameAchievementsTabBrain.vue": 21833,
	"./components/game/achievements/GameAchievementsTabGifts.vue": 2254,
	"./components/game/achievements/GameAchievementsTabStars.vue": 45761,
	"./components/game/days/w1d1/W1D1Achievements.vue": 69556,
	"./components/game/days/w1d1/W1D1Badge1.vue": 32817,
	"./components/game/days/w1d1/W1D1Exploration1.vue": 12534,
	"./components/game/days/w1d1/W1D1Exploration2.vue": 71609,
	"./components/game/days/w1d1/W1D1Exploration3.vue": 96181,
	"./components/game/days/w1d1/W1D1Exploration4.vue": 44816,
	"./components/game/days/w1d1/W1D1Game1.vue": 64409,
	"./components/game/days/w1d1/W1D1Game2.vue": 22988,
	"./components/game/days/w1d1/W1D1Game3.vue": 94400,
	"./components/game/days/w1d1/W1D1Game4.vue": 15572,
	"./components/game/days/w1d1/W1D1Game5.vue": 6874,
	"./components/game/days/w1d1/W1D1Game6.vue": 9899,
	"./components/game/days/w1d1/W1D1Offboarding.vue": 51441,
	"./components/game/days/w1d2/W1D2Achievements.vue": 38305,
	"./components/game/days/w1d2/W1D2Badge1.vue": 670,
	"./components/game/days/w1d2/W1D2Exploration1.vue": 80120,
	"./components/game/days/w1d2/W1D2Exploration2.vue": 86168,
	"./components/game/days/w1d2/W1D2Exploration3.vue": 46723,
	"./components/game/days/w1d2/W1D2Exploration4.vue": 1365,
	"./components/game/days/w1d2/W1D2Exploration5.vue": 82182,
	"./components/game/days/w1d2/W1D2Game1.vue": 52197,
	"./components/game/days/w1d2/W1D2Game2.vue": 78254,
	"./components/game/days/w1d2/W1D2Game3.vue": 44461,
	"./components/game/days/w1d2/W1D2Game4.vue": 36326,
	"./components/game/days/w1d2/W1D2Game5.vue": 6193,
	"./components/game/days/w1d2/W1D2Offboarding.vue": 59308,
	"./components/game/days/w1d3/W1D3Achievements.vue": 76310,
	"./components/game/days/w1d3/W1D3Badge1.vue": 90623,
	"./components/game/days/w1d3/W1D3Badge2.vue": 65479,
	"./components/game/days/w1d3/W1D3Exploration1.vue": 64773,
	"./components/game/days/w1d3/W1D3Exploration2.vue": 25106,
	"./components/game/days/w1d3/W1D3Exploration3.vue": 95322,
	"./components/game/days/w1d3/W1D3Exploration4.vue": 23441,
	"./components/game/days/w1d3/W1D3Game1.vue": 24280,
	"./components/game/days/w1d3/W1D3Game2.vue": 71830,
	"./components/game/days/w1d3/W1D3Game3.vue": 58062,
	"./components/game/days/w1d3/W1D3Game4.vue": 12438,
	"./components/game/days/w1d3/W1D3Offboarding.vue": 88221,
	"./components/game/days/w1d4/W1D4Achievements.vue": 6908,
	"./components/game/days/w1d4/W1D4Badge1.vue": 86979,
	"./components/game/days/w1d4/W1D4Exploration1.vue": 82816,
	"./components/game/days/w1d4/W1D4Exploration2.vue": 16433,
	"./components/game/days/w1d4/W1D4Exploration3.vue": 5038,
	"./components/game/days/w1d4/W1D4Exploration4.vue": 73490,
	"./components/game/days/w1d4/W1D4Game1.vue": 96101,
	"./components/game/days/w1d4/W1D4Game2.vue": 81056,
	"./components/game/days/w1d4/W1D4Game3.vue": 36638,
	"./components/game/days/w1d4/W1D4Game4.vue": 91574,
	"./components/game/days/w1d4/W1D4Offboarding.vue": 44057,
	"./components/game/days/w1d5/W1D5Achievements.vue": 19758,
	"./components/game/days/w1d5/W1D5Exploration1.vue": 84225,
	"./components/game/days/w1d5/W1D5Exploration2.vue": 59193,
	"./components/game/days/w1d5/W1D5Exploration4.vue": 37700,
	"./components/game/days/w1d5/W1D5Game1.vue": 29091,
	"./components/game/days/w1d5/W1D5Gift.vue": 69261,
	"./components/game/days/w1d5/W1D5Offboarding.vue": 35276,
	"./components/game/days/w2d1/W2D1Achievements.vue": 40905,
	"./components/game/days/w2d1/W2D1Exploration1.vue": 25274,
	"./components/game/days/w2d1/W2D1Exploration2.vue": 57228,
	"./components/game/days/w2d1/W2D1Exploration3.vue": 73498,
	"./components/game/days/w2d1/W2D1Game1.vue": 38786,
	"./components/game/days/w2d1/W2D1Game2.vue": 52415,
	"./components/game/days/w2d1/W2D1Game3.vue": 54281,
	"./components/game/days/w2d1/W2D1Game4.vue": 60362,
	"./components/game/days/w2d1/W2D1Offboarding.vue": 62231,
	"./components/game/days/w2d2/W2D2Achievements.vue": 98508,
	"./components/game/days/w2d2/W2D2Badge1.vue": 76512,
	"./components/game/days/w2d2/W2D2Exploration1.vue": 93005,
	"./components/game/days/w2d2/W2D2Exploration2.vue": 77174,
	"./components/game/days/w2d2/W2D2Exploration3.vue": 68689,
	"./components/game/days/w2d2/W2D2Exploration4.vue": 77726,
	"./components/game/days/w2d2/W2D2Game1.vue": 18271,
	"./components/game/days/w2d2/W2D2Game2.vue": 22330,
	"./components/game/days/w2d2/W2D2Game3.vue": 94106,
	"./components/game/days/w2d2/W2D2Game4.vue": 77961,
	"./components/game/days/w2d2/W2D2Game5.vue": 69391,
	"./components/game/days/w2d2/W2D2Offboarding.vue": 3395,
	"./components/game/days/w2d3/W2D3Achievements.vue": 97992,
	"./components/game/days/w2d3/W2D3Badge1.vue": 84689,
	"./components/game/days/w2d3/W2D3Exploration1.vue": 70629,
	"./components/game/days/w2d3/W2D3Exploration2.vue": 60336,
	"./components/game/days/w2d3/W2D3Exploration3.vue": 21685,
	"./components/game/days/w2d3/W2D3Exploration4.vue": 59081,
	"./components/game/days/w2d3/W2D3Game1.vue": 65494,
	"./components/game/days/w2d3/W2D3Game2.vue": 82922,
	"./components/game/days/w2d3/W2D3Game3.vue": 71401,
	"./components/game/days/w2d3/W2D3Game4.vue": 76189,
	"./components/game/days/w2d3/W2D3Offboarding.vue": 13335,
	"./components/game/days/w2d4/W2D4Achievements.vue": 62033,
	"./components/game/days/w2d4/W2D4Badge1.vue": 85983,
	"./components/game/days/w2d4/W2D4Exploration1.vue": 45971,
	"./components/game/days/w2d4/W2D4Exploration2.vue": 71748,
	"./components/game/days/w2d4/W2D4Exploration3.vue": 43910,
	"./components/game/days/w2d4/W2D4Exploration4.vue": 60239,
	"./components/game/days/w2d4/W2D4Exploration5.vue": 1059,
	"./components/game/days/w2d4/W2D4Game1.vue": 80983,
	"./components/game/days/w2d4/W2D4Game2.vue": 97769,
	"./components/game/days/w2d4/W2D4Game3.vue": 19264,
	"./components/game/days/w2d4/W2D4Game4.vue": 33578,
	"./components/game/days/w2d4/W2D4Offboarding.vue": 50869,
	"./components/game/days/w2d5/W2D5Achievements.vue": 69771,
	"./components/game/days/w2d5/W2D5Exploration1.vue": 79374,
	"./components/game/days/w2d5/W2D5Exploration2.vue": 18976,
	"./components/game/days/w2d5/W2D5Exploration3.vue": 25581,
	"./components/game/days/w2d5/W2D5Game1.vue": 86519,
	"./components/game/days/w2d5/W2D5Gift.vue": 91334,
	"./components/game/days/w2d5/W2D5Offboarding.vue": 33259,
	"./components/game/days/w3d1/W3D1Achievements.vue": 49486,
	"./components/game/days/w3d1/W3D1Badge1.vue": 51796,
	"./components/game/days/w3d1/W3D1Exploration1.vue": 10288,
	"./components/game/days/w3d1/W3D1Exploration2.vue": 43837,
	"./components/game/days/w3d1/W3D1Exploration3.vue": 50754,
	"./components/game/days/w3d1/W3D1Game1.vue": 7776,
	"./components/game/days/w3d1/W3D1Game2.vue": 94670,
	"./components/game/days/w3d1/W3D1Game3.vue": 39321,
	"./components/game/days/w3d1/W3D1Game4.vue": 5780,
	"./components/game/days/w3d1/W3D1Offboarding.vue": 57721,
	"./components/game/days/w3d2/W3D2Achievements.vue": 19700,
	"./components/game/days/w3d2/W3D2Badge1.vue": 74681,
	"./components/game/days/w3d2/W3D2Exploration1.vue": 81329,
	"./components/game/days/w3d2/W3D2Exploration2.vue": 72163,
	"./components/game/days/w3d2/W3D2Exploration3.vue": 44715,
	"./components/game/days/w3d2/W3D2Exploration4.vue": 38575,
	"./components/game/days/w3d2/W3D2Game1.vue": 75396,
	"./components/game/days/w3d2/W3D2Game2.vue": 92141,
	"./components/game/days/w3d2/W3D2Game3.vue": 23970,
	"./components/game/days/w3d2/W3D2Game4.vue": 80042,
	"./components/game/days/w3d2/W3D2Game5.vue": 39549,
	"./components/game/days/w3d2/W3D2Offboarding.vue": 99214,
	"./components/game/days/w3d3/W3D3Achievements.vue": 15476,
	"./components/game/days/w3d3/W3D3Badge1.vue": 94091,
	"./components/game/days/w3d3/W3D3Exploration1.vue": 45701,
	"./components/game/days/w3d3/W3D3Exploration2.vue": 20473,
	"./components/game/days/w3d3/W3D3Exploration3.vue": 31833,
	"./components/game/days/w3d3/W3D3Exploration4.vue": 87963,
	"./components/game/days/w3d3/W3D3Exploration5.vue": 11908,
	"./components/game/days/w3d3/W3D3Exploration6.vue": 66160,
	"./components/game/days/w3d3/W3D3Exploration7.vue": 71691,
	"./components/game/days/w3d3/W3D3Game1.vue": 30538,
	"./components/game/days/w3d3/W3D3Game2.vue": 16665,
	"./components/game/days/w3d3/W3D3Game3.vue": 80707,
	"./components/game/days/w3d3/W3D3Game4.vue": 39650,
	"./components/game/days/w3d3/W3D3Game5.vue": 13816,
	"./components/game/days/w3d3/W3D3Game6.vue": 52621,
	"./components/game/days/w3d3/W3D3Game7.vue": 15152,
	"./components/game/days/w3d3/W3D3Offboarding.vue": 81024,
	"./components/game/days/w3d4/W3D4Achievements.vue": 18560,
	"./components/game/days/w3d4/W3D4Badge1.vue": 78420,
	"./components/game/days/w3d4/W3D4Exploration1.vue": 13285,
	"./components/game/days/w3d4/W3D4Exploration2.vue": 79029,
	"./components/game/days/w3d4/W3D4Exploration3.vue": 96005,
	"./components/game/days/w3d4/W3D4Exploration4.vue": 26490,
	"./components/game/days/w3d4/W3D4Game1.vue": 41992,
	"./components/game/days/w3d4/W3D4Game2.vue": 92602,
	"./components/game/days/w3d4/W3D4Game3.vue": 65606,
	"./components/game/days/w3d4/W3D4Game4.vue": 33622,
	"./components/game/days/w3d4/W3D4Offboarding.vue": 7505,
	"./components/game/days/w3d5/W3D5Achievements.vue": 24526,
	"./components/game/days/w3d5/W3D5Exploration1.vue": 68509,
	"./components/game/days/w3d5/W3D5Exploration2.vue": 29578,
	"./components/game/days/w3d5/W3D5Exploration3.vue": 76749,
	"./components/game/days/w3d5/W3D5Game1.vue": 67186,
	"./components/game/days/w3d5/W3D5Gift.vue": 38014,
	"./components/game/days/w3d5/W3D5Offboarding.vue": 82535,
	"./components/game/days/w4d1/W4D1Achievements.vue": 78778,
	"./components/game/days/w4d1/W4D1Badge1.vue": 59692,
	"./components/game/days/w4d1/W4D1Exploration1.vue": 73945,
	"./components/game/days/w4d1/W4D1Exploration2.vue": 11725,
	"./components/game/days/w4d1/W4D1Exploration3.vue": 15269,
	"./components/game/days/w4d1/W4D1Exploration4.vue": 6639,
	"./components/game/days/w4d1/W4D1Exploration5.vue": 43884,
	"./components/game/days/w4d1/W4D1Exploration6.vue": 63391,
	"./components/game/days/w4d1/W4D1Exploration7.vue": 23105,
	"./components/game/days/w4d1/W4D1Game1.vue": 73488,
	"./components/game/days/w4d1/W4D1Game2.vue": 9037,
	"./components/game/days/w4d1/W4D1Game3.vue": 97161,
	"./components/game/days/w4d1/W4D1Game4.vue": 26884,
	"./components/game/days/w4d1/W4D1Offboarding.vue": 35573,
	"./components/game/days/w4d2/W4D2Achievements.vue": 60349,
	"./components/game/days/w4d2/W4D2Badge1.vue": 70456,
	"./components/game/days/w4d2/W4D2Exploration1.vue": 53988,
	"./components/game/days/w4d2/W4D2Exploration2.vue": 53422,
	"./components/game/days/w4d2/W4D2Exploration3.vue": 45119,
	"./components/game/days/w4d2/W4D2Exploration4.vue": 9833,
	"./components/game/days/w4d2/W4D2Exploration5.vue": 93437,
	"./components/game/days/w4d2/W4D2Exploration6.vue": 64912,
	"./components/game/days/w4d2/W4D2Exploration7.vue": 92567,
	"./components/game/days/w4d2/W4D2Game1.vue": 25564,
	"./components/game/days/w4d2/W4D2Game2.vue": 98191,
	"./components/game/days/w4d2/W4D2Game3.vue": 75795,
	"./components/game/days/w4d2/W4D2Game4.vue": 57802,
	"./components/game/days/w4d2/W4D2Game5.vue": 41392,
	"./components/game/days/w4d2/W4D2Offboarding.vue": 18184,
	"./components/game/days/w4d3/W4D3Achievements.vue": 81346,
	"./components/game/days/w4d3/W4D3Badge1.vue": 11699,
	"./components/game/days/w4d3/W4D3Exploration1.vue": 12962,
	"./components/game/days/w4d3/W4D3Exploration2.vue": 76792,
	"./components/game/days/w4d3/W4D3Exploration3.vue": 1105,
	"./components/game/days/w4d3/W4D3Exploration4.vue": 2933,
	"./components/game/days/w4d3/W4D3Exploration5.vue": 76192,
	"./components/game/days/w4d3/W4D3Exploration6.vue": 92240,
	"./components/game/days/w4d3/W4D3Game1.vue": 42026,
	"./components/game/days/w4d3/W4D3Game2.vue": 53286,
	"./components/game/days/w4d3/W4D3Game3.vue": 74013,
	"./components/game/days/w4d3/W4D3Game4.vue": 82977,
	"./components/game/days/w4d3/W4D3Game5.vue": 68497,
	"./components/game/days/w4d3/W4D3Offboarding.vue": 99229,
	"./components/game/days/w4d4/W4D4Achievements.vue": 41242,
	"./components/game/days/w4d4/W4D4Badge1.vue": 55152,
	"./components/game/days/w4d4/W4D4Exploration1.vue": 15295,
	"./components/game/days/w4d4/W4D4Exploration2.vue": 23341,
	"./components/game/days/w4d4/W4D4Exploration3.vue": 83115,
	"./components/game/days/w4d4/W4D4Exploration4.vue": 72783,
	"./components/game/days/w4d4/W4D4Exploration5.vue": 46463,
	"./components/game/days/w4d4/W4D4Game1.vue": 99813,
	"./components/game/days/w4d4/W4D4Game2.vue": 13655,
	"./components/game/days/w4d4/W4D4Game3.vue": 11326,
	"./components/game/days/w4d4/W4D4Game4.vue": 56128,
	"./components/game/days/w4d4/W4D4Offboarding.vue": 99797,
	"./components/game/days/w4d5/W4D5Achievements.vue": 48993,
	"./components/game/days/w4d5/W4D5Exploration1.vue": 90134,
	"./components/game/days/w4d5/W4D5Exploration2.vue": 90605,
	"./components/game/days/w4d5/W4D5Exploration3.vue": 15234,
	"./components/game/days/w4d5/W4D5Game1.vue": 10837,
	"./components/game/days/w4d5/W4D5Gift.vue": 88267,
	"./components/game/days/w4d5/W4D5Offboarding.vue": 95823,
	"./components/game/help/GameHelp.vue": 20940,
	"./components/game/help/GameHelpTabContact.vue": 31847,
	"./components/game/help/GameHelpTabGeneral.vue": 82127,
	"./components/game/help/GameHelpTabQuestions.vue": 35413,
	"./components/game/partials/GameAnimationConfetti.vue": 6933,
	"./components/game/partials/GameBadge.vue": 72497,
	"./components/game/partials/GameButton.vue": 55331,
	"./components/game/partials/GameCircuitCircle.vue": 77580,
	"./components/game/partials/GameCircuitLine.vue": 2725,
	"./components/game/partials/GameDailyAchievements.vue": 56528,
	"./components/game/partials/GameExtrastars.vue": 88052,
	"./components/game/partials/GameFindIt.vue": 76500,
	"./components/game/partials/GameFinishedPlanetPopup.vue": 75666,
	"./components/game/partials/GameHeader.vue": 13277,
	"./components/game/partials/GameLogoutCockpit.vue": 20692,
	"./components/game/partials/GameNavItem.vue": 73474,
	"./components/game/partials/GameNextButton.vue": 69813,
	"./components/game/partials/GameOffboarding.vue": 61155,
	"./components/game/partials/GamePauseCockpit.vue": 67906,
	"./components/game/partials/GamePauseFinishedCockpit.vue": 95647,
	"./components/game/partials/GamePauseHelp.vue": 43378,
	"./components/game/partials/GamePlanetView.vue": 98108,
	"./components/game/partials/GameReceiveBadge.vue": 51055,
	"./components/game/partials/GameSkip.vue": 15121,
	"./components/game/partials/GameStarSpeechBubble.vue": 12502,
	"./components/game/partials/GameStatusHeader.vue": 48022,
	"./components/game/surprises/GameSurprises.vue": 31050,
	"./components/game/surprises/GameSurprisesStars.vue": 50635,
	"./components/game/surprises/GameSurprisesText.vue": 44963,
	"./components/home/HomeShow.vue": 88978,
	"./components/home/PrivacyPolicyShow.vue": 28504,
	"./components/home/partials/HomeAdvantages.vue": 87142,
	"./components/home/partials/HomeBadge.vue": 90596,
	"./components/home/partials/HomeContact.vue": 34003,
	"./components/home/partials/HomeFaq.vue": 91416,
	"./components/home/partials/HomeFooter.vue": 99853,
	"./components/home/partials/HomeGrowth.vue": 72141,
	"./components/home/partials/HomeMaterial.vue": 48814,
	"./components/home/partials/HomeNav.vue": 77463,
	"./components/home/partials/HomeNavbar.vue": 6210,
	"./components/home/partials/HomePlanets.vue": 59367,
	"./components/home/partials/HomePlay.vue": 3147,
	"./components/home/partials/HomePoweredBy.vue": 93314,
	"./components/home/partials/HomePrivacyPolicy.vue": 34757,
	"./components/home/partials/HomeQuotes.vue": 51522,
	"./components/home/partials/HomeRegisterDialog.vue": 53125,
	"./components/home/partials/HomeTopbar.vue": 84083,
	"./components/imports/ImportWidget.vue": 18983,
	"./components/links/LinksActions.vue": 9503,
	"./components/links/LinksIndex.vue": 81427,
	"./components/monitoring/ActivityMonitoring.vue": 11393,
	"./components/monitoring/ClassroomMonitoring.vue": 55318,
	"./components/monitoring/Monitoring.vue": 51248,
	"./components/monitoring/OverallMonitoring.vue": 56928,
	"./components/monitoring/PupilMonitoring.vue": 4000,
	"./components/news/Editor.vue": 67611,
	"./components/news/NewsActions.vue": 29060,
	"./components/news/NewsIndex.vue": 24967,
	"./components/news/NewsShow.vue": 74486,
	"./components/partials/FileUploader.vue": 50954,
	"./components/partials/RegisterReason.vue": 39455,
	"./components/pixi/PixiAnimatedSprite.vue": 58570,
	"./components/pixi/PixiBar.vue": 58807,
	"./components/pixi/PixiBox.vue": 6195,
	"./components/pixi/PixiButton.vue": 92979,
	"./components/pixi/PixiCheckbox.vue": 95659,
	"./components/pixi/PixiCircle.vue": 80032,
	"./components/pixi/PixiContainer.vue": 71280,
	"./components/pixi/PixiInput.vue": 13791,
	"./components/pixi/PixiRect.vue": 63314,
	"./components/pixi/PixiRenderer.vue": 46712,
	"./components/pixi/PixiSelect.vue": 18247,
	"./components/pixi/PixiSpeechBubble.vue": 85159,
	"./components/pixi/PixiSprite.vue": 5268,
	"./components/pixi/PixiText.vue": 4178,
	"./components/pixi/PixiVideo.vue": 5792,
	"./components/users/UserFormDialog.vue": 78111,
	"./components/users/UserIndex.vue": 18402,
	"./components/users/UserRating.vue": 14287,
	"./components/users/UserResultsDialog.vue": 48397
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66106;